'use client';

import { useEffect } from 'react';
import { useGoogleAnalytics, initMixpanel } from '@/lib/analytics';

export default function GoogleAnalytics() {
  useGoogleAnalytics();

  useEffect(() => {
    initMixpanel();
  }, []);

  return null;
}
